<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-typhoon`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 8V4C15.163 4 8 11.163 8 20s7.163 16 16 16v-.04a11.944 11.944 0 006.696-1.589A11.943 11.943 0 0036 28c0 6.627-5.373 12-12 12v4c8.837 0 16-7.163 16-16 0-6.967-4.453-12.894-10.668-15.09a11.98 11.98 0 00-10.636.677 11.995 11.995 0 00-6.002 10.445A11.98 11.98 0 0112 20c0-6.627 5.373-12 12-12zm-6.233 19.979a8 8 0 016.303-11.977L24 16c1.364 0 2.674.227 3.896.646A8 8 0 1117.768 27.98z"/></svg>
</template>
<script>

export default {
  name: 'IconTyphoon',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
